/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CompleteEventResponseDto } from '../model';
// @ts-ignore
import type { CreateCompleteEventDto } from '../model';
// @ts-ignore
import type { CreateMultipleChallengeEntitlementsDto } from '../model';
// @ts-ignore
import type { GetChallengeEntitlementResponseDto } from '../model';
/**
 * ChallengeOrchestrationApi - axios parameter creator
 * @export
 */
export const ChallengeOrchestrationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a complete event with categories and entitlements
         * @param {CreateCompleteEventDto} createCompleteEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeOrchestrationControllerCreateCompleteEvent: async (createCompleteEventDto: CreateCompleteEventDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCompleteEventDto' is not null or undefined
            assertParamExists('challengeOrchestrationControllerCreateCompleteEvent', 'createCompleteEventDto', createCompleteEventDto)
            const localVarPath = `/api/challenge-orchestration/complete-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCompleteEventDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create multiple entitlements for a category
         * @param {string} categoryId Category ID
         * @param {CreateMultipleChallengeEntitlementsDto} createMultipleChallengeEntitlementsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeOrchestrationControllerCreateEntitlementsForCategory: async (categoryId: string, createMultipleChallengeEntitlementsDto: CreateMultipleChallengeEntitlementsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('challengeOrchestrationControllerCreateEntitlementsForCategory', 'categoryId', categoryId)
            // verify required parameter 'createMultipleChallengeEntitlementsDto' is not null or undefined
            assertParamExists('challengeOrchestrationControllerCreateEntitlementsForCategory', 'createMultipleChallengeEntitlementsDto', createMultipleChallengeEntitlementsDto)
            const localVarPath = `/api/challenge-orchestration/categories/{categoryId}/entitlements/bulk`
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMultipleChallengeEntitlementsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a complete event with all categories and entitlements
         * @param {string} challengeId Challenge ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeOrchestrationControllerGetCompleteEvent: async (challengeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'challengeId' is not null or undefined
            assertParamExists('challengeOrchestrationControllerGetCompleteEvent', 'challengeId', challengeId)
            const localVarPath = `/api/challenge-orchestration/complete-events/{challengeId}`
                .replace(`{${"challengeId"}}`, encodeURIComponent(String(challengeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove all entitlements for a category
         * @param {string} categoryId Category ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeOrchestrationControllerRemoveEntitlementsForCategory: async (categoryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('challengeOrchestrationControllerRemoveEntitlementsForCategory', 'categoryId', categoryId)
            const localVarPath = `/api/challenge-orchestration/categories/{categoryId}/entitlements`
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a complete event with categories and entitlements
         * @param {string} challengeId Challenge ID
         * @param {CreateCompleteEventDto} createCompleteEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeOrchestrationControllerUpdateCompleteEvent: async (challengeId: string, createCompleteEventDto: CreateCompleteEventDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'challengeId' is not null or undefined
            assertParamExists('challengeOrchestrationControllerUpdateCompleteEvent', 'challengeId', challengeId)
            // verify required parameter 'createCompleteEventDto' is not null or undefined
            assertParamExists('challengeOrchestrationControllerUpdateCompleteEvent', 'createCompleteEventDto', createCompleteEventDto)
            const localVarPath = `/api/challenge-orchestration/{challengeId}`
                .replace(`{${"challengeId"}}`, encodeURIComponent(String(challengeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCompleteEventDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChallengeOrchestrationApi - functional programming interface
 * @export
 */
export const ChallengeOrchestrationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChallengeOrchestrationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a complete event with categories and entitlements
         * @param {CreateCompleteEventDto} createCompleteEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async challengeOrchestrationControllerCreateCompleteEvent(createCompleteEventDto: CreateCompleteEventDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompleteEventResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.challengeOrchestrationControllerCreateCompleteEvent(createCompleteEventDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChallengeOrchestrationApi.challengeOrchestrationControllerCreateCompleteEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create multiple entitlements for a category
         * @param {string} categoryId Category ID
         * @param {CreateMultipleChallengeEntitlementsDto} createMultipleChallengeEntitlementsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async challengeOrchestrationControllerCreateEntitlementsForCategory(categoryId: string, createMultipleChallengeEntitlementsDto: CreateMultipleChallengeEntitlementsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetChallengeEntitlementResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.challengeOrchestrationControllerCreateEntitlementsForCategory(categoryId, createMultipleChallengeEntitlementsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChallengeOrchestrationApi.challengeOrchestrationControllerCreateEntitlementsForCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a complete event with all categories and entitlements
         * @param {string} challengeId Challenge ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async challengeOrchestrationControllerGetCompleteEvent(challengeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompleteEventResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.challengeOrchestrationControllerGetCompleteEvent(challengeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChallengeOrchestrationApi.challengeOrchestrationControllerGetCompleteEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove all entitlements for a category
         * @param {string} categoryId Category ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async challengeOrchestrationControllerRemoveEntitlementsForCategory(categoryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.challengeOrchestrationControllerRemoveEntitlementsForCategory(categoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChallengeOrchestrationApi.challengeOrchestrationControllerRemoveEntitlementsForCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a complete event with categories and entitlements
         * @param {string} challengeId Challenge ID
         * @param {CreateCompleteEventDto} createCompleteEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async challengeOrchestrationControllerUpdateCompleteEvent(challengeId: string, createCompleteEventDto: CreateCompleteEventDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompleteEventResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.challengeOrchestrationControllerUpdateCompleteEvent(challengeId, createCompleteEventDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChallengeOrchestrationApi.challengeOrchestrationControllerUpdateCompleteEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChallengeOrchestrationApi - factory interface
 * @export
 */
export const ChallengeOrchestrationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChallengeOrchestrationApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a complete event with categories and entitlements
         * @param {CreateCompleteEventDto} createCompleteEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeOrchestrationControllerCreateCompleteEvent(createCompleteEventDto: CreateCompleteEventDto, options?: RawAxiosRequestConfig): AxiosPromise<CompleteEventResponseDto> {
            return localVarFp.challengeOrchestrationControllerCreateCompleteEvent(createCompleteEventDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create multiple entitlements for a category
         * @param {string} categoryId Category ID
         * @param {CreateMultipleChallengeEntitlementsDto} createMultipleChallengeEntitlementsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeOrchestrationControllerCreateEntitlementsForCategory(categoryId: string, createMultipleChallengeEntitlementsDto: CreateMultipleChallengeEntitlementsDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetChallengeEntitlementResponseDto>> {
            return localVarFp.challengeOrchestrationControllerCreateEntitlementsForCategory(categoryId, createMultipleChallengeEntitlementsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a complete event with all categories and entitlements
         * @param {string} challengeId Challenge ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeOrchestrationControllerGetCompleteEvent(challengeId: string, options?: RawAxiosRequestConfig): AxiosPromise<CompleteEventResponseDto> {
            return localVarFp.challengeOrchestrationControllerGetCompleteEvent(challengeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove all entitlements for a category
         * @param {string} categoryId Category ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeOrchestrationControllerRemoveEntitlementsForCategory(categoryId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.challengeOrchestrationControllerRemoveEntitlementsForCategory(categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a complete event with categories and entitlements
         * @param {string} challengeId Challenge ID
         * @param {CreateCompleteEventDto} createCompleteEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengeOrchestrationControllerUpdateCompleteEvent(challengeId: string, createCompleteEventDto: CreateCompleteEventDto, options?: RawAxiosRequestConfig): AxiosPromise<CompleteEventResponseDto> {
            return localVarFp.challengeOrchestrationControllerUpdateCompleteEvent(challengeId, createCompleteEventDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChallengeOrchestrationApi - object-oriented interface
 * @export
 * @class ChallengeOrchestrationApi
 * @extends {BaseAPI}
 */
export class ChallengeOrchestrationApi extends BaseAPI {
    /**
     * 
     * @summary Create a complete event with categories and entitlements
     * @param {CreateCompleteEventDto} createCompleteEventDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengeOrchestrationApi
     */
    public challengeOrchestrationControllerCreateCompleteEvent(createCompleteEventDto: CreateCompleteEventDto, options?: RawAxiosRequestConfig) {
        return ChallengeOrchestrationApiFp(this.configuration).challengeOrchestrationControllerCreateCompleteEvent(createCompleteEventDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create multiple entitlements for a category
     * @param {string} categoryId Category ID
     * @param {CreateMultipleChallengeEntitlementsDto} createMultipleChallengeEntitlementsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengeOrchestrationApi
     */
    public challengeOrchestrationControllerCreateEntitlementsForCategory(categoryId: string, createMultipleChallengeEntitlementsDto: CreateMultipleChallengeEntitlementsDto, options?: RawAxiosRequestConfig) {
        return ChallengeOrchestrationApiFp(this.configuration).challengeOrchestrationControllerCreateEntitlementsForCategory(categoryId, createMultipleChallengeEntitlementsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a complete event with all categories and entitlements
     * @param {string} challengeId Challenge ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengeOrchestrationApi
     */
    public challengeOrchestrationControllerGetCompleteEvent(challengeId: string, options?: RawAxiosRequestConfig) {
        return ChallengeOrchestrationApiFp(this.configuration).challengeOrchestrationControllerGetCompleteEvent(challengeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove all entitlements for a category
     * @param {string} categoryId Category ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengeOrchestrationApi
     */
    public challengeOrchestrationControllerRemoveEntitlementsForCategory(categoryId: string, options?: RawAxiosRequestConfig) {
        return ChallengeOrchestrationApiFp(this.configuration).challengeOrchestrationControllerRemoveEntitlementsForCategory(categoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a complete event with categories and entitlements
     * @param {string} challengeId Challenge ID
     * @param {CreateCompleteEventDto} createCompleteEventDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengeOrchestrationApi
     */
    public challengeOrchestrationControllerUpdateCompleteEvent(challengeId: string, createCompleteEventDto: CreateCompleteEventDto, options?: RawAxiosRequestConfig) {
        return ChallengeOrchestrationApiFp(this.configuration).challengeOrchestrationControllerUpdateCompleteEvent(challengeId, createCompleteEventDto, options).then((request) => request(this.axios, this.basePath));
    }
}

